<div [ngClass]="{'navigation-disabled':disableNavigation}" class="navigation-container">
  <p class="navigate-to-list mb-3x" (click)="navigateToOverview()" (keydown.enter)="navigateToOverview()">
    {{'COMMON_UI.NAVIGATION.BUTTON_TEXT' | translate}}
  </p>
  <h5 class="mb-1x" id="navigationHeadline">{{navigationConfig?.headlineKey | translate}}</h5>
  <p class="mb-3x">{{mandantenName}} | {{mandantenNr}} | {{beraterNr}}</p>
  <ul class="navigation-list">
    <ng-container *ngFor="let item of navigationConfig?.items">
      <li *ngIf="isVisible(item)"
          [ngClass]="item.items?.length > 0 ? 'navigation-multi-item' : 'navigation-single-item'"
          routerLinkActive="active">
        <h5 [routerLink]="item.route"
            id="{{item.id}}"
            routerLinkActive="active"
            (keydown.enter)="onNavigationClick(item.route, $event)"
            (click)="onNavigationClick(item.route)">
          {{item.labelKey | translate}}
        </h5>
        <ul *ngIf="item.items?.length > 0" [ngClass]="['navigation-sub-items']" routerLinkActive="active">
          <ng-container *ngFor="let subItem of item.items">
            <li *ngIf="isVisible(subItem)" [ngClass]="['navigation-sub-item']"
                [routerLink]="subItem.route"
                id="{{subItem.id}}"
                routerLinkActive="active"
                (keydown.enter)="onNavigationClick(subItem.route, $event)"
                (click)="onNavigationClick(subItem.route)">
              <h6>{{subItem.labelKey | translate}}</h6>
            </li>
          </ng-container>
        </ul>
      </li>
    </ng-container>
  </ul>
  <p class="watermark">{{appName}} - Version 202401</p>
</div>
